import React from 'react';
import { Spring } from 'react-spring';
import PropTypes from 'prop-types';
import { LoginForm } from 'C4';
import i18n from 'i18n-react';

import Logo from 'assets/images/logo/logo_dark.png';
import placeholderLogo from 'assets/images/logo/logo.png';
import virtualLogo from 'assets/images/logo/logo_virtual.png';
import darklogo from 'assets/images/logo/logo_white.png';

// const MobileButtons = () => (
//   <div className="button__container">
//     <p className="title">Download Now:</p>
//     <div className="buttons small">
//       <a href={appleStore} target="_blank" rel="noopener noreferrer">
//         <img src={apple} alt="App store" />
//       </a>
//       <a href={googleStore} rel="noopener noreferrer">
//         <img src={google} alt="Google Play" />
//       </a>
//     </div>
//   </div>
// );

const SponsorButtons = () => (
  <div className="powered">
    <text>Powered by</text>
    <img src={`/${darklogo}`} className="logo__bottom" alt="logo" />
  </div>
);

const REGISTER_URLS = ['attendee', 'exhibitor'];

export default class LoginView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showLogo: false,
    };
    this.toggleContent = this.toggleContent.bind(this);
  }

  toggleContent() {
    this.setState({ popup: true });
  }

  componentDidMount() {
    const { logout } = this.props;

    if (REGISTER_URLS.every((url) => !window.location.href.includes(url))) {
      if (!logout) {
        document.getElementById('introVid').addEventListener(
          'ended',
          () => {
            this.setState({ open: true });
          },
          false,
        );
        setTimeout(() => {
          this.setState({ open: true });
        }, 10000);
      }
    }
  }

  render() {
    const { open, showLogo } = this.state;
    const { logout } = this.props;

    const enableLogo = () => {
      this.setState({ showLogo: true });
    };

    if (!REGISTER_URLS.every((url) => !window.location.href.includes(url))) {
      return (
        <div className="loginViewNormal">
          <div className="loginView__bg">
            <div className="loginView__bg--content">
            </div>
          </div>
          <div className="loginView__content">
            <LoginForm path={this.props.match.path} />
          </div>
        </div>
      );
    }

    if (logout) {
      return (
        <div className="loginView">
          <img className="loginView__bigLogo" src={virtualLogo} alt="virtuallogo" />

          <div className="loginLogo" style={{ visibility: showLogo ? undefined : 'hidden' }}>
            <h3>Welcome to</h3>
            <img src={placeholderLogo} alt="Company Logo" />
          </div>
          <div className="buttonWrapper">
            <SponsorButtons />
          </div>
          <Spring from={{ transform: 'translateX(0%)' }} to={{ transform: 'translateX(-26%)' }}>
            {(props) => (
              <React.Fragment>
                <img
                  src={placeholderLogo}
                  className="logoVid "
                  alt="logo"
                  style={{ visibility: open ? 'hidden' : undefined }}
                />
              </React.Fragment>
            )}
          </Spring>
          <Spring
            from={{ transform: 'translateX(100%)', opacity: 0 }}
            to={{ transform: 'translateX(0%)', opacity: 1 }}
          >
            {(props) => (
              <div className="loginView__content" style={props}>
                <button onClick={this.toggleContent} className="loginView__content--request">
                  Request login
                </button>
                <img src={Logo} className="loginView__content--logo" alt="Logo" />
                <LoginForm path={this.props.match.path} />
              </div>
            )}
          </Spring>
        </div>
      );
    }
    return (
      <div className="loginView">
        <div className="loginLogo" style={{ visibility: showLogo ? undefined : 'hidden' }}>
          <img className="loginView__bigLogo" src={placeholderLogo} alt="Company Logo" />

          <h3>Welcome to the</h3>
          <img
            src={placeholderLogo}
            alt="Company Logo"
            style={{ visibility: showLogo ? undefined : 'hidden' }}
          />
        </div>
        <div className="buttonWrapper">
          <SponsorButtons />
        </div>
        <Spring
          from={{ transform: 'translateX(0%)' }}
          to={{ transform: open ? 'translateX(-26%)' : 'translateX(0%)' }}
        >
          {(props) => (
            <React.Fragment>
              <img
                src={placeholderLogo}
                className="logoVid"
                alt="logo"
                style={{ visibility: open ? 'hidden' : undefined }}
              />
            </React.Fragment>
          )}
        </Spring>
        <Spring
          from={{ transform: 'translateX(100%)', opacity: 0 }}
          to={{ transform: open ? 'translateX(0%)' : 'translateX(100%)', opacity: open ? 1 : 0 }}
        >
          {(props) => (
            <div className="loginView__content" style={props}>
              <button onClick={this.toggleContent} className="loginView__content--request">
                Request login
              </button>
              <img src={Logo} className="loginView__content--logo" alt="Logo" />
              <LoginForm path={this.props.match.path} />
            </div>
          )}
        </Spring>
      </div>
    );
  }
}

LoginView.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }),
  logout: PropTypes.bool,
};

LoginView.defaultProps = {
  match: {
    path: '/login',
  },
  logout: false,
};
